import React from "react";

function OrangeGlobe() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="25"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.18945 9.37435C2.50906 5.06389 6.10757 1.66602 10.4997 1.66602C9.80732 1.66602 9.19085 1.96952 8.6837 2.43362C8.1791 2.89539 7.75268 3.54 7.40779 4.30198C7.06086 5.06845 6.79137 5.96492 6.60897 6.93778C6.46276 7.71763 6.37378 8.53978 6.34412 9.37435H2.18945ZM2.18945 10.6243H6.34412C6.37378 11.4589 6.46276 12.2811 6.60897 13.0609C6.79137 14.0338 7.06086 14.9302 7.40779 15.6967C7.75268 16.4587 8.1791 17.1033 8.6837 17.5651C9.19085 18.0292 9.80732 18.3327 10.4997 18.3327C6.10757 18.3327 2.50906 14.9348 2.18945 10.6243Z"
        fill="#DAAE3E"
      />
      <path
        d="M10.4997 1.66602C11.1921 1.66602 11.8086 1.96952 12.3157 2.43362C12.8203 2.89539 13.2467 3.54 13.5916 4.30198C13.9385 5.06845 14.208 5.96492 14.3904 6.93778C14.5366 7.71764 14.6256 8.53978 14.6553 9.37435H18.8099C18.4903 5.06389 14.8918 1.66602 10.4997 1.66602Z"
        fill="#DAAE3E"
      />
      <path
        d="M14.3904 13.0609C14.208 14.0338 13.9385 14.9302 13.5916 15.6967C13.2467 16.4587 12.8203 17.1033 12.3157 17.5651C11.8086 18.0292 11.1921 18.3327 10.4997 18.3327C14.8918 18.3327 18.4903 14.9348 18.8099 10.6243H14.6553C14.6256 11.4589 14.5366 12.2811 14.3904 13.0609Z"
        fill="#DAAE3E"
      />
      <g opacity="0.5">
        <path
          d="M10.5002 2.83008C10.2711 2.83008 9.975 2.92759 9.63074 3.24263C9.28393 3.56 8.93674 4.05741 8.63 4.7351C8.32529 5.40829 8.07786 6.22096 7.9076 7.12912C7.77351 7.8443 7.69032 8.60244 7.66113 9.37562H13.3393C13.3101 8.60244 13.227 7.8443 13.0929 7.12912C12.9226 6.22096 12.6752 5.40829 12.3705 4.7351C12.0637 4.05741 11.7165 3.56001 11.3697 3.24263C11.0255 2.92759 10.7294 2.83008 10.5002 2.83008Z"
          fill="#DAAE3E"
        />
        <path
          d="M7.9076 12.8721C8.07786 13.7803 8.32529 14.5929 8.63 15.2661C8.93674 15.9438 9.28393 16.4412 9.63073 16.7586C9.975 17.0736 10.2711 17.1712 10.5002 17.1712C10.7294 17.1712 11.0255 17.0736 11.3697 16.7586C11.7165 16.4412 12.0637 15.9438 12.3705 15.2661C12.6752 14.593 12.9226 13.7803 13.0929 12.8721C13.227 12.1569 13.3101 11.3988 13.3393 10.6256H7.66113C7.69032 11.3988 7.77351 12.1569 7.9076 12.8721Z"
          fill="#DAAE3E"
        />
      </g>
    </svg>
  );
}

export default OrangeGlobe;
